import { commonRoutes } from '../../routes/commonRoutes';
export const rentalRoutes = commonRoutes;
